
import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ManageCentersService {

  constructor(private api: ApiService) { }

  getAllCenter(data: any): Observable<any> {
    return this.api.post(environment.getAllCenter, data);
  }

  createCenter(data: any): Observable<any> {
    return this.api.post(environment.createCenter, data);
  }

  updateCenter(data: any): Observable<any> {
    return this.api.post(environment.updateCenter, data);
  }

  deleteCenter(data: any): Observable<any> {
    return this.api.post(environment.deleteCenter, data);
  }
}
